import * as localAPI from "localAPI";
import models from "models/models";
import readlangClient from "readlangClient";

import * as languageMap from "shared/languageMap";

const cache = new Map<string, string>();

const getCacheKey = (language: string, type: string, text: string) =>
  `${language}-${type}-${text}`;

export const show = async (language: string) =>
  languageMap.map[language].transliterations?.length > 0 &&
  !(await localAPI.isLocalMode()) &&
  models.user.hasFeature("showTransliterations");

export const fetch = async (
  language: string,
  text: string
): Promise<string> => {
  const type = languageMap.map[language].transliterations?.[0];

  const key = getCacheKey(language, type, text);

  const cachedValue = cache.get(key);
  if (cachedValue) {
    return cachedValue;
  }

  // Get transliteration
  const transliterationType = languageMap.map[language].transliterations?.[0];
  if (!transliterationType) {
    return;
  }

  let transliteration: any;
  try {
    transliteration = (
      await readlangClient.request(
        "GET",
        "/api/smartDictionary/transliteration",
        {
          language,
          text,
          type,
        },
        undefined,
        undefined,
        { dataType: "text" }
      )
    ).data;
  } catch (error) {
    console.error("Error getting transliteration: ", error);
    return;
  }

  return transliteration;
};
